import { Component, Input } from '@angular/core';
import { ImplementerService } from '../../../services/implementer/implementer.service';
import { DailyLogPermissions } from '../../../models/permissions/permission.models';
import { ImplementerSnapshotSummary } from '../../../models/implementer/implementer.models';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { CompleteDayEditor } from '../../../models/complete-day.models';
import { NavController } from 'ionic-angular';
import { ImplementerCancelPage } from '../implementer-cancel/implementer-cancel/implementer-cancel-page';
import { ImplementerMergePage } from '../implementer-merge/implementer-merge/implementer-merge-page';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';
import { AppConfig } from '../../../app/app.config';

@Component({
  selector: 'implementer-navigator-component',
  templateUrl: 'implementer-navigator-component.html'
})
export class ImplementerNavigatorComponent {
  @Input() dailyLogDate: PtLuxonDate;

  config = AppConfig.settings;

  permissions: DailyLogPermissions = new DailyLogPermissions();
  loading: boolean;
  snapshotSummary: ImplementerSnapshotSummary;
  completeDayEditors: CompleteDayEditor[];
  mergeAvailable: boolean;

  constructor(
    private implementerService: ImplementerService,
    private permissionService: PermissionsService,
    private navCtrl: NavController,
    private timeZoneService: TimeZoneService,
  ) {

  }

  async ngOnInit() {
    this.loading = true;
    this.permissions = await this.permissionService.dailyLogPermissions();
    await this.checkTimeZones();
    this.snapshotSummary = await this.implementerService.getActiveSnapshotSummary(this.config.isVesselEnvironment);
    this.completeDayEditors = await this.implementerService.getImplementerCompleteDayEditors(this.config.isVesselEnvironment);
    this.mergeAvailable = this.completeDayEditors.every(e => e.isComplete);
  }

  async mergeImplementerChanges() {
    this.navCtrl.push(ImplementerMergePage, {snapshotSummary: this.snapshotSummary});
  }

  async cancelImplementerChanges() {
    this.navCtrl.push(ImplementerCancelPage, {snapshotSummary: this.snapshotSummary});
  }

  finishLoading(calendarLoaded: boolean) {
    if (calendarLoaded) {
      this.loading = false;
    }
  }

  async checkTimeZones() {
    const timeZones = await this.timeZoneService.getAllTimeZones();

    // no timezones here means that the user hasn't loaded the log yet, should only happen the first time the user loads this site - but still need to
    // account for it - so we need to load timezones from the api and save to local storage as they are needed when loading dates for the navigator
    if (!timeZones || timeZones.length === 0) {
      await this.timeZoneService.updateTimeZonesFromApi();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-navigator-component/implementer-navigator-component.ts